import { Component,OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PetService } from '../../../../services/pet.service';

@Component({
  selector: 'ngx-svg-maps',
  templateUrl: './svg-maps.component.html', 
})
export class SvgMapsComponent implements OnInit {

  constructor(
    public petService: PetService,
  ) { }

  @Input() curr_pet: string = ''
  @Input() mapTitle: string = ''
 

  ngOnInit() {
     
  } 
  

  selectedToothId: number | null = null;
  selectedTooth: number = 0;
  tooth_option = []

  @Output() pathClickedValue = new EventEmitter<number>(); // Renamed for clarity

  @Input() activePathId: string | null = null; // Still useful for highlighting
 
  isToothSelected(toothId: number): boolean {
    return this.selectedToothId === toothId;
  } 

  isToothInProblem(toothId: number): boolean {
    return this.petService.pet_dental.tooth_problem.some(
      (problem) => Number(problem.tooth_no) === toothId
    );
  }

  toothClicked(toothId: number) { 
    this.selectedToothId = toothId; 
    this.petService.pet_tooth.tooth_no = String(toothId);  
  }  



}
